module.exports = __webpack_public_path__ + "static/media/358.770dd998.webp";